import { Collapse, Form, FormInstance, Input } from "antd";
import styled from "styled-components";
import { ImageUpload } from "../../../ui/formItemComponents/ImageUpload";
import { mimeTypes } from "../../story/components/form/InitialStoryForm";
import { Wysiwyg } from "../../../ui/wysiwyg/Wysiwig";
import { addContentImage } from "../../../api/requests/content";

const uploadImage = `${process.env.REACT_APP_CONTENT}/Content/AddImage`;

interface IProps {
  form: FormInstance<any>;
  lang: string;
}

export const FormPlayerOfMatch = ({ form, lang }: IProps) => {
  return (
    <Container>
      {/* <Collapse>
        <Collapse.Panel header="Баннер на главной странице" key={"banner"}>
          <Form.Item name={"banner"}>
            <ImageUpload
              updateImage={form.getFieldValue("banner")}
              name={"banner"}
              label="Баннер"
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 375,
                height: 80,
                size: 10
              }}
              form={form}
            />
          </Form.Item>
        </Collapse.Panel>
      </Collapse> */}
      <Collapse>
        <Collapse.Panel header="Превью на странице “Акции”" key={"preview"}>
          <Form.Item name={"preview"}>
            <ImageUpload
              updateImage={form.getFieldValue("preview")}
              name={"preview"}
              label="Превью"
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 343,
                height: 154,
                size: 10
              }}
              form={form}
            />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>
      <Collapse>
        <Collapse.Panel header="Об акции" key={"about"}>
          <Form.Item label="Заголовок" name={["about", "title", lang]}>
            <Input />
          </Form.Item>
          <Form.Item label="Текст на странице “Акции”" name={["about", "pageText", lang]}>
            <Wysiwyg uploadRequest={addContentImage} />
          </Form.Item>
          <Form.Item label="Текст в карточке акции" name={["about", "cardText", lang]}>
            <Wysiwyg uploadRequest={addContentImage} />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>

      {/**Правила акции */}
      <Collapse>
        <Collapse.Panel header="Правила акции" key={"rules"}>
          <Form.Item label={"Дата редакции"} name={["rules", "date", lang]}>
            <Input />
          </Form.Item>
          <br />
          <Form.Item name={["rules", "text", lang]}>
            <Wysiwyg uploadRequest={addContentImage} />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .ant-form-item {
    margin: 0;
  }

  .ant-row {
    display: flex;
    flex-direction: column;

    .ant-col {
      text-align: left;
    }
  }

  .ant-form-item-control-input-content {
    & > div {
    }
  }
`;
